import { useState, useEffect } from "react";
import { useLoadScript } from "@react-google-maps/api";

// Define libraries as a constant outside the component to prevent re-renders
const libraries = ["places"];

/**
 * Custom hook for managing Google Maps Places API
 *
 * Usage:
 * const { addressService, nzBounds, isLoaded } = useGoogleMaps();
 */
export function useGoogleMaps() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY,
    libraries
  });

  const [addressService, setAddressService] = useState(null);

  // Initialize AutocompleteService once Maps is loaded
  useEffect(() => {
    if (isLoaded && window.google && window.google.maps && window.google.maps.places) {
      setAddressService(
        new window.google.maps.places.AutocompleteService()
      );
    }
  }, [isLoaded]);

  // Bounds for New Zealand (used in other parts of the app)
  const nzBounds = isLoaded && window.google && window.google.maps && window.google.maps.LatLngBounds
    ? new window.google.maps.LatLngBounds(
        { lat: -47.3, lng: 166.9 },
        { lat: -34.4, lng: 178.6 }
      )
    : null;

  // Bounds specifically for Auckland region
  const aucklandBounds = isLoaded && window.google && window.google.maps && window.google.maps.LatLngBounds
    ? new window.google.maps.LatLngBounds(
        { lat: -37.15, lng: 174.45 },  // Southwest corner of Auckland
        { lat: -36.65, lng: 175.25 }   // Northeast corner of Auckland
      )
    : null;

  return {
    isLoaded,
    addressService,
    nzBounds,
    aucklandBounds
  };
}
